export default "__VITE_ASSET__OyIS2rg9__"